import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[checkoutSubscriptionBlockHost]',
    standalone: true,
})
export class SubscriptionBlockDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
